import template from './mayday_level_3_banner.html'
const maydayLevel3Banner = {
  restrict: 'A',
  controllerAs: '$ctrl',
  bindings: {
    bannerKey: '<',
  },
  template,
  controller: [
    'urlConstants',
    'globalBannerTracking',
    'applicationConstants',
    function (urlConstants, globalBannerTracking, applicationConstants) {
      this.$onInit = () => {
        this.bannerPhone = applicationConstants.support.maydayBannerPhone
      }

      this.redirectToCta = () => {
        this.setCookie()
        globalBannerTracking.clickBannerCTA(this.bannerKey)
        document.location = urlConstants.contractor.leadsDashboardTabURL
      }

      this.close = () => {
        this.setCookie()
        globalBannerTracking.clickClose(this.bannerKey)
        this.closed = true
      }

      this.setCookie = () => {
        const now = new Date()
        const expiry = new Date(
          now.getFullYear(),
          now.getMonth() + 6,
          now.getDate()
        )
        Cookie.set(this.bannerKey, 1, expiry)
      }
    },
  ],
}

export default maydayLevel3Banner
